export default __webpack_public_path__ + "static/media/Animals_05.c8edf1e8.png";